// The Joulukampanja heroes' chevron (added in includes/joulu/functions.php): scrolls to just past the hero.
// The navbar hides while scrolling down, so nothing covers the content there.
document.addEventListener("click", (event) => {
  const button = event.target.closest(".joulu-hero__scroll");
  if (!button) {
    return;
  }

  const hero = button.closest(".joulu-hero");
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  window.scrollTo({
    top: hero.getBoundingClientRect().bottom + window.scrollY,
    behavior: reduceMotion ? "auto" : "smooth",
  });
});
